<div
  class="card-form-group-container"
  [formGroup]="form">
  <mat-form-field>
    <input
      matInput
      placeholder="Unità di misura (MIFU)"
      formControlName="MIFU">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Altezza (MIFA)"
      formControlName="MIFA">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Larghezza (MIFL)"
      formControlName="MIFL">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Diametro (MIFD)"
      formControlName="MIFD">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Varie (MIFV)"
      formControlName="MIFV">
  </mat-form-field>
</div>
